import { useCallback, useContext, useState } from "react";
import MessageView from "./messageView/messageView";
import NotificationView from "./notificationView/notificationView";
import { CommunicationViewTypes } from "./types/communicationViewProps";
import { ReactComponent as ErrorIcon } from "../../../icons/error.svg";
import { ReactComponent as UserIcon } from "../../../icons/account_circle.svg";
import { ReactComponent as EventIcon } from "../../../icons/event.svg";
import { ReactComponent as CalculateIcon } from "../../../icons/calculate.svg";
import { ReactComponent as ShowMenu } from '../../../icons/view_comfy_alt.svg';
import MenuField from "../../../components/filterMenuField/filterMenuField";
import FilterMenuText from "../../../components/filterMenuItemField/filterMenuText";
import FilterMenuDate from "../../../components/filterMenuItemField/filterMenuDate";
import ToggleButton from "../../../components/toggleButton/toggleButton";
import AuthContext, { NotificationTypeShown } from "../../../contexts/authContext";
import ReadNMessageView from "./messageView/readMessageView";
import './communicationView.scss';
import { getMsgFilter, getNotifyFilter } from "../../../services/communicationService/communicationFilter";
import { toQueryDateFilter } from "../../../helpers/filter";

const CommunicationView = (props: any) => {
    const { userId, username, userConfig } = useContext(AuthContext);
    const [viewType, setViewType] = useState<CommunicationViewTypes>(CommunicationViewTypes.Notification);
    const [readView, setReadView] = useState<boolean>(false);
    const [selected, setSelected] = useState<__esri.Graphic | null>(null);
    const [btnToggle, setBtnToggle] = useState<boolean>(true);
    const [notifyWhere, setNotifyWhere] = useState<any>({ date: null, text: null, category: null });
    const [msgWhere, setMsgWhere] = useState<any>({ date: null, text: null, user: null });
    const [notifyActive, setNotifyActive] = useState<boolean>(false);
    const [msgActive, setMsgActive] = useState<boolean>(false);

    const renderView = (viewType: number) => {
        switch (viewType) {
            case CommunicationViewTypes.Notification:
                return (<NotificationView where={getFilter()} />)
            case CommunicationViewTypes.Message:
                return (<MessageView where={getFilter()} onRead={handleReadView}/>)
        }
    }

    const handleTextFilterChange = (value?: string) => {
        if (viewType === CommunicationViewTypes.Notification) {
            setNotifyWhere({ ...notifyWhere, text: value });
        } else {
            setMsgWhere({ ...msgWhere, text: value });
        }
    }

    const handleDateFilterChange = (value?: number) => {
        if (viewType === CommunicationViewTypes.Notification) {
            const newWhere = { ...notifyWhere, date: value };
            setNotifyWhere(newWhere);
            setActiveState(newWhere, viewType);
        } else {
            const newWhere = { ...msgWhere, date: value };
            setMsgWhere(newWhere)
            setActiveState(newWhere, viewType);
        }
    }

    const handleUserFilterChange = (value?: string) => {
        const newWhere = { ...msgWhere, user: value };
        setMsgWhere(newWhere);
        setActiveState(newWhere, viewType);
    }

    const handleCategoryFilterChange = (value?: string) => {
        const newWhere = { ...notifyWhere, category: value };
        setNotifyWhere(newWhere);
        setActiveState(newWhere, viewType);
    }

    const setActiveState = (where: any, view: CommunicationViewTypes) => {
        if (view === CommunicationViewTypes.Notification) {
            const isActive = isNotEmpty(where.date) || isNotEmpty(where.category);
            setNotifyActive(isActive);
        } else {
            const isActive = isNotEmpty(where.date) || isNotEmpty(where.user);
            setMsgActive(isActive);
        }
    }

    const isNotEmpty = (value: string | null) => {
        return value !== null && value !== undefined && value !== "";
    }

    const getFilter = () => {
        let filter = getConfigFilter(userConfig.notificationTypeShown);
        if (viewType === CommunicationViewTypes.Notification) {
            filter += getFilterExpr(notifyWhere);
        } else {
            filter += getFilterExpr(msgWhere);
        }
        return filter;
    }

    const getFilterExpr = (where: any) => {
        let expr = "";
        if (isNotEmpty(where.text)) {
            expr += toLike("TRESC", where.text);
        }
        if (isNotEmpty(where.user)) {
            expr += toLike("NAZWA_PELNA", where.user);
        }
        if (isNotEmpty(where.date)) {
            expr += "AND " + toQueryDateFilter("DATA_WYSLANIA", where.date);
        }
        if (isNotEmpty(where.category)) {
            expr += toLike("KATEGORIA_DOM_WARTOSC", where.category);
        }
        return expr;
    }

    const toLike = (field: string, value: string) => {
        return ` AND LOWER(${field}) LIKE LOWER('%${value}%')`;
    }
 
    const getConfigFilter = useCallback((typeShown: NotificationTypeShown) => {
        if (viewType === CommunicationViewTypes.Notification) {
            return getNotifyFilter(typeShown, userId);
        } else {
            return getMsgFilter(typeShown, username);
        }
    }, [userId, username, viewType])

    const handleNotificationClick = () => {
        handleClick(notifyWhere, CommunicationViewTypes.Notification);
    }

    const handleMessageClick = () => {
        handleClick(msgWhere, CommunicationViewTypes.Message);
    }

    const handleClick = (where: any, view: CommunicationViewTypes) => {
        setViewType(view);
        setBtnToggle(!btnToggle);
        setActiveState(where, view);
    }

    const handleReadView = (show: boolean, feature: __esri.Graphic | null) => {
        console.log(feature);
        setReadView(show);
        setSelected(feature);
    }

    return (<div className="communicationView">
        <div style={{display: readView ? 'none' : 'block'}}>
            <h1>Komunikacja</h1>
            <div className="communicationView-info-text body-txt-large">
                <ErrorIcon color="black" />
                <div>Odczytane {viewType === CommunicationViewTypes.Notification ? "powiadomienia" : "wiadomości"} są usuwane automatycznie po upływie 30 dni.</div>
                <div></div>
                <div style={{visibility: viewType === CommunicationViewTypes.Notification ? 'hidden' : 'visible'}}>Jeśli nie chcesz, aby wiadomość została usunięta, oznacz ją.</div>
            </div>
        </div>
        <div className="communicationView-tools" style={{display: readView ? 'none' : 'flex'}}>
            <MenuField id={"notify"} style={{ display: viewType === CommunicationViewTypes.Notification ? 'flex' : 'none' }} active={notifyActive} label={"Filtruj"} placeholder={"Szukaj"} additionalIcon={CalculateIcon} hideLabel={true} onChange={handleTextFilterChange}>
                <FilterMenuText id={"category"} active={true} additionalIcon={ShowMenu} label={"Kategoria"} placeholder={"Wpisz kategorię"} onChange={handleCategoryFilterChange} />
                <FilterMenuDate id={"date"} active={true} additionalIcon={EventIcon} label={"Data"} single={true} onChange={handleDateFilterChange} />
            </MenuField>
            <MenuField id={"msg"} style={{ display: viewType === CommunicationViewTypes.Message ? 'flex' : 'none' }} active={msgActive} label={"Filtruj"} placeholder={"Szukaj"} additionalIcon={CalculateIcon} hideLabel={true} onChange={handleTextFilterChange}>
                <FilterMenuText id={"user"} active={true} additionalIcon={UserIcon} label={"Nadawca"} placeholder={"Wpisz Imię i Nazwisko"} onChange={handleUserFilterChange} />
                <FilterMenuDate id={"date"} active={true} additionalIcon={EventIcon} label={"Data"} single={true} onChange={handleDateFilterChange} />
            </MenuField>
            <ToggleButton
                btnToggle={btnToggle}
                setBtnToggle={setBtnToggle}
                leftText={"Powiadomienia"}
                rightText={"Wiadomości"}
                onChangeLeft={handleNotificationClick}
                onChangeRight={handleMessageClick}
            />
        </div>
        {readView ? <ReadNMessageView feature={selected} onRead={handleReadView}/> : renderView(viewType)}
    </div>);
}

export default CommunicationView;
